export const blockIconsHardwarePhoneiPhoneNew = (
	<span className='material-symbols-outlined'>phone_iphone</span>
);
